export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/family.8a93972d-1fe85c.svg";